export const REQUIRED = 'REQUIRED'
export const MAX = 'MAX'
export const MIN = 'MIN'
